import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { InputAdornment, TextField } from '@material-ui/core';
import { StyledTag } from './TagInputTextField.style';

var TagInputTextField = function TagInputTextField(_ref) {
  var params = _ref.params,
      label = _ref.label,
      errorMessage = _ref.errorMessage,
      inputRef = _ref.inputRef;
  return __jsx(TextField, _extends({}, params, {
    variant: "outlined",
    label: label,
    error: Boolean(errorMessage),
    helperText: errorMessage,
    inputRef: inputRef,
    InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
      startAdornment: __jsx(React.Fragment, null, __jsx(InputAdornment, {
        position: "start"
      }, __jsx(StyledTag, null)), params.InputProps.startAdornment)
    })
  }));
};

export default TagInputTextField;